import { Text } from '@thanx/uikit/text'
import React from 'react'

import { termsOfServiceApi } from 'api/termsOfService'
import Spinner from 'components/Spinner'
import { buildTranslate } from 'locales'
import Helmet from 'react-helmet'

const getTranslations = () => {
  const t = buildTranslate('privacy.privacy')
  const titles = buildTranslate('titles')
  return { t, titles }
}

type Props = {
  handle: string
  testId?: string
}

const ThanxPrivacy = ({ handle, testId }: Props) => {
  const { t, titles } = getTranslations()

  const { data, isLoading } =
    termsOfServiceApi.useGetTermsOfServiceQuery(handle)

  const { merchant_name } = data ?? {}

  return (
    <div className="p-xl pt-xl" data-testid={testId}>
      {isLoading && (
        <Spinner className="mt-xl text-center" isLoading size="2x" />
      )}
      {!isLoading && merchant_name && (
        <div>
          <Helmet>
            <title>{titles('privacy_branded', { name: merchant_name })}</title>
          </Helmet>
          <Text.Header2>{t('merchant', { name: merchant_name })}</Text.Header2>
        </div>
      )}
      <Text.Header2>{t('title')}</Text.Header2>
      <Text.BodyText2 className="italic">{t('effective_date')}</Text.BodyText2>
      <br />
      <br />
      <Text.BodyText3>
        <a
          style={{
            cursor: 'pointer',
            textDecoration: 'underline',
            color: 'blue',
          }}
          onClick={() => {
            document
              .getElementById('supplemental')
              ?.scrollIntoView({ behavior: 'smooth' })
          }}
        >
          {t('see_supplemental')}
        </a>
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('intro') }} />
      </Text.BodyText3>
      <br />
      <br />
      <ol>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('services_list.one') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('services_list.two') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('services_list.three') }}
            />
          </Text.BodyText3>
        </li>
      </ol>
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('services_definition') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('collection_header') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('provided_by_you') }} />
      </Text.BodyText3>
      <br />
      <br />
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.contact'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.profile'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.payment'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.order'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.image'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.communications'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('provided_by_you_list.preferences'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('third_party_sources') }} />
      </Text.BodyText3>
      <br />
      <br />
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('third_party_list.transaction'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('third_party_list.merchant'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('auto_collected') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('auto_collected_list.device'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('auto_collected_list.online'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('auto_collected_list.geolocation'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('cookies_header') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('cookies_list.cookies') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('cookies_list.beacons') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('cookies_list.sdks') }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('cookies_third_party') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('cookies_types') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('cookies_types_list.advertising'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('cookies_types_list.analytics'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('cookies_types_list.essential'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('cookies_choices') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('use_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('use_intro') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span dangerouslySetInnerHTML={{ __html: t('use_list.provide') }} />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span dangerouslySetInnerHTML={{ __html: t('use_list.enable') }} />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('use_list.communicate') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('use_list.merchant_messages'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('use_list.personalize') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span dangerouslySetInnerHTML={{ __html: t('use_list.support') }} />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('merchant_use') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('merchant_use_list.analyze'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('merchant_use_list.marketing'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('merchant_use_list.advertising'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('merchant_use_list.comply'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('sharing_header') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('sharing_intro') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('thanx_merchants') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('branded_services') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('service_providers') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('compliance') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('business_transactions') }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('choices_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('choices_intro') }} />
      </Text.BodyText3>
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('choices_list.opt_out') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{ __html: t('choices_list.account') }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('choices_list.google_analytics'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('merchant_choices') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('links_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('links') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('children_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('children') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('do_not_track_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('do_not_track') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('supplemental_header') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('supplemental_intro') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_table_intro') }}
        />
      </Text.BodyText3>
      <br />
      <table>
        <thead>
          <tr>
            {(Object.values(t('supplemental_table.headers')) as string[]).map(
              (header: string, index: number) => (
                <th
                  key={`header_${index}`}
                  style={{
                    border: '1px solid black',
                    padding: '5px',
                    backgroundColor: '#f2f2f2',
                  }}
                >
                  <Text.BodyText3>
                    <span dangerouslySetInnerHTML={{ __html: header }} />
                  </Text.BodyText3>
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {(Object.values(t('supplemental_table.rows')) as string[][]).map(
            (row: string[], rowIndex: number) => (
              <tr key={`row_${rowIndex}`}>
                {Object.values(row).map((cell: string, cellIndex: number) => (
                  <td
                    key={`cell_${cellIndex}`}
                    style={{ border: '1px solid black', padding: '5px' }}
                  >
                    <Text.BodyText3>
                      <span dangerouslySetInnerHTML={{ __html: cell }} />
                    </Text.BodyText3>
                  </td>
                ))}
              </tr>
            )
          )}
        </tbody>
      </table>
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{
            __html: t('supplemental_other_disclosures'),
          }}
        />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('supplemental_sale') }} />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_sensitive') }}
        />
      </Text.BodyText3>
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('supplemental_rights') }} />
      </Text.BodyText3>
      <br />
      <br />
      <ul>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('supplemental_rights_list.disclose'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('supplemental_rights_list.delete'),
              }}
            />
          </Text.BodyText3>
        </li>
        <li>
          <Text.BodyText3>
            <span
              dangerouslySetInnerHTML={{
                __html: t('supplemental_rights_list.correct'),
              }}
            />
          </Text.BodyText3>
        </li>
      </ul>
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_verified') }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_limitations') }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{
            __html: t('supplemental_nondiscrimination'),
          }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('supplemental_appeal') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_ca_rights') }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span
          dangerouslySetInnerHTML={{ __html: t('supplemental_incentive') }}
        />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('contact') }} />
      </Text.BodyText3>
      <br />
      <br />
      <Text.BodyText3>
        <span dangerouslySetInnerHTML={{ __html: t('last_updated') }} />
      </Text.BodyText3>
    </div>
  )
}

export default ThanxPrivacy
